import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  AlertController,
  IonicPage,
  NavController,
  NavParams,
} from 'ionic-angular';
import { UtilProvider } from '../../providers/util/util';

/**
 * Generated class for the TextEditerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-text-editer',
  templateUrl: 'text-editer.html',
})
export class TextEditerPage {
  @ViewChild('changeEdit') changeEdit: ElementRef;

  content: string = '';

  //允许的最大长度
  maxSize: number = 500;

  //编辑完成后的回调
  onFinished: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public util: UtilProvider,
    public alertCtrl: AlertController
  ) {
    this.content = this.navParams.get('text');
    this.onFinished = this.navParams.get('onFinished');
  }

  ionViewDidLoad() {}

  ionViewDidEnter() {}

  cancelEdit() {
    this.navCtrl.pop();
  }

  saveEdit() {
    if (this.content.length > this.maxSize) {
      this.util.alertHintMsg(this.alertCtrl, '提示', '输入的字数超出限制');
    } else {
      this.navCtrl.pop();
      this.onFinished(this.content);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/text-editer/text-editer.ts